module.exports = __webpack_public_path__ + "static/media/s-small.0cc4008e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/planets/s-small.png
// module id = 1870
// module chunks = 0